import axios from "axios";

function queryString(params = {}) {
    const query = new URLSearchParams();
    Object.keys(params).forEach((key) => {
        const value = params[key];
        if (value !== undefined && value !== null && value !== "") {
            query.append(key, value);
        }
    });
    const text = query.toString();
    return text ? `?${text}` : "";
}

function unwrap(promise) {
    return promise.then((res) => {
        if (res.data.code === 200 || res.data.code === "200") {
            return res.data;
        }
        return Promise.reject(res.data);
    });
}

export function getOpenApiAppPage(params) {
    return unwrap(axios.get(`/api/bms/openapi/app/page${queryString(params)}`));
}

export function saveOpenApiApp(data) {
    return unwrap(axios.post("/api/bms/openapi/app/save", data));
}

export function enableOpenApiApp(data) {
    return unwrap(axios.post("/api/bms/openapi/app/enable", data));
}

export function disableOpenApiApp(data) {
    return unwrap(axios.post("/api/bms/openapi/app/disable", data));
}

export function resetOpenApiSecrets(data) {
    return unwrap(axios.post("/api/bms/openapi/app/resetSecrets", data));
}

export function getOpenApiSecrets(data) {
    return unwrap(axios.post("/api/bms/openapi/app/secrets", data));
}

export function getOpenApiProductPage(params) {
    return unwrap(axios.get(`/api/bms/openapi/product/page${queryString(params)}`));
}

export function saveOpenApiProduct(data) {
    return unwrap(axios.post("/api/bms/openapi/product/save", data, {
        headers: { "Content-Type": "application/json" }
    }));
}

export function deleteOpenApiProduct(data) {
    return unwrap(axios.post("/api/bms/openapi/product/delete", data, {
        headers: { "Content-Type": "application/json" }
    }));
}

export function getOpenApiInterfacePage(params) {
    return unwrap(axios.get(`/api/bms/openapi/interface/page${queryString(params)}`));
}

export function saveOpenApiInterface(data) {
    return unwrap(axios.post("/api/bms/openapi/interface/save", data, {
        headers: { "Content-Type": "application/json" }
    }));
}

export function getOpenApiAppProductPage(params) {
    return unwrap(axios.get(`/api/bms/openapi/app-product/page${queryString(params)}`));
}

export function saveOpenApiAppProduct(data) {
    return unwrap(axios.post("/api/bms/openapi/app-product/save", data, {
        headers: { "Content-Type": "application/json" }
    }));
}

export function deleteOpenApiAppProduct(data) {
    return unwrap(axios.post("/api/bms/openapi/app-product/delete", data, {
        headers: { "Content-Type": "application/json" }
    }));
}

export function getOpenApiOrderPage(params) {
    return unwrap(axios.get(`/api/bms/openapi/order/page${queryString(params)}`));
}

export function refundOpenApiOrder(data) {
    return unwrap(axios.post("/api/bms/openapi/order/refund", data));
}

export function getOpenApiOrderRefund(orderId) {
    return unwrap(axios.get(`/api/bms/openapi/order/${orderId}/refund`));
}

export function getOpenApiOrderReport(orderId) {
    return unwrap(axios.get(`/api/bms/openapi/order/${orderId}/report`));
}

export function regenerateOpenApiReport(orderId) {
    return unwrap(axios.post(`/api/bms/openapi/order/${orderId}/report/regenerate`));
}

export function retryOpenApiReportImage(orderId) {
    return unwrap(axios.post(`/api/bms/openapi/order/${orderId}/report/image`));
}

export function getOpenApiReportHistory(orderId) {
    return unwrap(axios.get(`/api/bms/openapi/order/${orderId}/report/history`));
}

export function previewOpenApiReportCleanup(archiveId) {
    return unwrap(axios.get(`/api/bms/openapi/order/report/archive/${archiveId}/cleanup-preview`));
}

export function getOpenApiCallRecordPage(params) {
    return unwrap(axios.get(`/api/bms/openapi/call-record/page${queryString(params)}`));
}

export function getOpenApiCallbackRecordPage(params) {
    return unwrap(axios.get(`/api/bms/openapi/callback-record/page${queryString(params)}`));
}

export function getOpenApiBalancePage(params) {
    return unwrap(axios.get(`/api/bms/openapi/balance/page${queryString(params)}`));
}

export function rechargeOpenApiBalance(data) {
    return unwrap(axios.post("/api/bms/openapi/balance/recharge", data));
}

export function reduceOpenApiBalance(data) {
    return unwrap(axios.post("/api/bms/openapi/balance/reduce", data));
}

export function getOpenApiBalanceFlowPage(params) {
    return unwrap(axios.get(`/api/bms/openapi/balance/flow/page${queryString(params)}`));
}

export function getOpenApiStatementSummary(params) {
    return unwrap(axios.get(`/api/bms/openapi/statement/summary${queryString(params)}`));
}
